import { PalettesProps } from '@ant-design/colors';
import { CustomColor as LabeledColor, CustomPalette } from 'themes';

// ==============================|| PRESET THEME - THEME SELECTOR ||============================== //

export type SimpleColor = string[] & {
    primary?: string | undefined;
};

const toLabeledColor = (color: SimpleColor): LabeledColor => ({
    0: color[0],
    50: color[1],
    100: color[2],
    200: color[3],
    300: color[4],
    400: color[5],
    500: color[6],
    600: color[7],
    700: color[8],
    800: color[9],
    900: color[10],
    A50: color[15],
    A100: color[11],
    A200: color[12],
    A400: color[13],
    A700: color[14],
    A800: color[16]
});

const Theme = (colors: PalettesProps): Partial<CustomPalette> => {
    const { blue, red, gold, cyan, green, grey, geekblue } = colors;

    const greyColors = toLabeledColor(grey);
    const cyanColors = toLabeledColor(cyan);

    const contrastText = '#fff';

    return {
        primary: {
            0: blue[0],
            lighter: blue[0],
            100: blue[1],
            200: blue[2],
            300: blue[3],
            light: blue[3],
            400: blue[4],
            500: blue[5],
            main: blue[5],
            600: blue[6],
            dark: blue[6],
            700: blue[7],
            800: blue[8],
            darker: blue[8],
            900: blue[9],
            contrastText
        },
        secondary: {
            0: cyanColors[0],
            lighter: cyanColors[100],
            100: cyanColors[100],
            200: cyanColors[200],
            300: cyanColors[300],
            light: cyanColors[300],
            400: cyanColors[400],
            500: cyanColors[500],
            main: cyanColors[500],
            600: cyanColors[600],
            700: cyanColors[700],
            dark: cyanColors[700],
            800: cyanColors[800],
            900: cyanColors[900],
            darker: cyanColors[900],
            A100: cyanColors[0],
            A200: cyanColors.A400,
            A300: cyanColors.A700,
            contrastText: grey[0]
        },
        error: {
            0: red[0],
            lighter: red[0],
            100: red[1],
            200: red[2],
            light: red[2],
            300: red[3],
            400: red[4],
            main: red[4],
            500: red[5],
            600: red[6],
            700: red[7],
            dark: red[7],
            800: red[8],
            900: red[9],
            darker: red[9],
            contrastText
        },
        warning: {
            0: gold[0],
            lighter: gold[0],
            100: gold[1],
            200: gold[2],
            300: gold[3],
            light: gold[3],
            400: gold[4],
            500: gold[5],
            main: gold[5],
            600: gold[6],
            700: gold[7],
            dark: gold[7],
            800: gold[8],
            900: gold[9],
            darker: gold[9],
            contrastText: greyColors[100]
        },
        info: {
            0: geekblue[0],
            lighter: geekblue[0],
            100: geekblue[1],
            200: geekblue[2],
            300: geekblue[3],
            light: geekblue[3],
            400: geekblue[4],
            500: geekblue[5],
            main: geekblue[5],
            600: geekblue[6],
            700: geekblue[7],
            dark: geekblue[7],
            800: geekblue[8],
            900: geekblue[9],
            darker: geekblue[9],
            contrastText
        },
        success: {
            0: green[0],
            lighter: green[0],
            100: green[1],
            200: green[2],
            300: green[3],
            light: green[3],
            400: green[4],
            500: green[5],
            main: green[5],
            600: green[6],
            700: green[7],
            dark: green[7],
            800: green[8],
            900: green[9],
            darker: green[9],
            contrastText
        },
        grey: greyColors
    };
};

export default Theme;
